/**
 * ECOSAC — main-product.js
 * Controles interativos da PDP:
 * - Troca de imagem via thumbnails
 * - Controle de quantidade (+ / −)
 * - Atualização de total em tempo real
 * - Troca de variante + atualização de preço e estoque
 * - Tabs de conteúdo (acessível: ARIA)
 */

(function () {
  'use strict';

  /* ============================================================
     GALERIA — troca de imagem principal ao clicar no thumbnail
     ============================================================ */
  function initGallery() {
    var thumbs   = document.querySelectorAll('.pdp-gallery__thumb');
    var mainImg  = document.getElementById('pdp-img-main');

    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var newSrc = this.dataset.imageSrc;
        var newAlt = this.dataset.imageAlt;

        if (!newSrc) return;

        // Troca imagem com fade rápido
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = newSrc;
          mainImg.alt = newAlt || '';
          mainImg.style.opacity = '1';
        }, 150);

        // Atualiza estado ativo
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ============================================================
     QUANTIDADE — botões + e −, atualiza total
     ============================================================ */
  function initQtyControl() {
    var btnMinus  = document.getElementById('pdp-qty-minus');
    var btnPlus   = document.getElementById('pdp-qty-plus');
    var input     = document.getElementById('pdp-qty-input');
    var totalEl   = document.getElementById('pdp-qty-total');
    var priceEl   = document.getElementById('pdp-price-value');

    if (!btnMinus || !btnPlus || !input) return;

    function getBasePrice() {
      if (!priceEl) return 0;
      // Pega o valor numérico do preço exibido (formato: R$ 8,90)
      var raw = priceEl.dataset.cents;
      return raw ? parseInt(raw, 10) : 0;
    }

    function updateTotal(qty) {
      renderPix(qty);
      if (!totalEl) return;
      var cents = getBasePrice();
      if (cents <= 0) return;
      var total = (cents * qty) / 100;
      totalEl.textContent = 'R$ ' + total.toFixed(2).replace('.', ',');
    }

    function setQty(val) {
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 999;
      val = Math.max(min, Math.min(max, val));
      input.value = val;
      updateTotal(val);
    }

    btnMinus.addEventListener('click', function () {
      setQty(parseInt(input.value, 10) - 1);
    });

    btnPlus.addEventListener('click', function () {
      setQty(parseInt(input.value, 10) + 1);
    });

    input.addEventListener('change', function () {
      setQty(parseInt(this.value, 10) || 1);
    });

    input.addEventListener('input', function () {
      updateTotal(parseInt(this.value, 10) || 1);
    });
  }

  /* ============================================================
     VARIANTES — troca variant ID, preço, estoque sem reload
     ============================================================ */
  function initVariants() {
    var form        = document.getElementById('pdp-form');
    var variantInput = document.getElementById('pdp-variant-id');
    var options      = document.querySelectorAll('.pdp-variants__radio');

    if (!form || !options.length) return;

    options.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Atualiza visual dos labels
        var groupIndex = this.dataset.optionIndex;
        document
          .querySelectorAll('[data-option-index="' + groupIndex + '"]')
          .forEach(function (r) {
            r.closest('.pdp-variants__option').classList.remove('is-active');
          });
        this.closest('.pdp-variants__option').classList.add('is-active');

        // Dispara evento nativo do Shopify para sincronizar variant ID
        // O tema deve escutar 'change' no form para atualizar via /variants.json
        form.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Escuta evento customizado do Shopify (variant:change) para atualizar UI
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      // Atualiza ID da variante
      if (variantInput) variantInput.value = variant.id;

      // Atualiza preço
      updatePrice(variant);

      // Atualiza estoque
      updateStock(variant);

      // Atualiza botão CTA
      updateCTA(variant);

      // Re-calcula total com nova quantidade
      var qtyInput = document.getElementById('pdp-qty-input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var totalEl = document.getElementById('pdp-qty-total');
      if (totalEl && variant.price) {
        var total = (variant.price * qty) / 100;
        totalEl.textContent = 'R$ ' + total.toFixed(2).replace('.', ',');
      }

      // Atualiza o valor no Pix com a nova variante
      var pixBox = document.getElementById('pdp-pix');
      if (pixBox && variant.price) pixBox.dataset.cents = variant.price;
      renderPix(qty);
    });
  }

  function updatePrice(variant) {
    var priceEl       = document.getElementById('pdp-price-value');
    var oldPriceEl    = document.querySelector('.pdp-price__old s');
    var savingsEl     = document.querySelector('.pdp-price__savings');

    if (priceEl) {
      priceEl.textContent  = formatMoney(variant.price);
      priceEl.dataset.cents = variant.price;
    }

    if (oldPriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        oldPriceEl.textContent = formatMoney(variant.compare_at_price);
        oldPriceEl.closest('.pdp-price__old').style.display = '';
      } else {
        oldPriceEl.closest('.pdp-price__old').style.display = 'none';
      }
    }

    if (savingsEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var saving = variant.compare_at_price - variant.price;
        var pct    = Math.round(saving * 100 / variant.compare_at_price);
        savingsEl.textContent = '↓ Economize ' + formatMoney(saving) + ' · ' + pct + '% off';
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }
  }

  function updateStock(variant) {
    var stockEl = document.getElementById('pdp-stock');
    if (!stockEl) return;

    var dot   = stockEl.querySelector('.pdp-stock__dot');
    var label = stockEl.querySelector('.pdp-stock__label');

    if (variant.available) {
      if (dot)   { dot.className   = 'pdp-stock__dot pdp-stock__dot--in'; }
      if (label) { label.className = 'pdp-stock__label pdp-stock__label--in'; label.textContent = 'Em estoque'; }
    } else {
      if (dot)   { dot.className   = 'pdp-stock__dot pdp-stock__dot--out'; }
      if (label) { label.className = 'pdp-stock__label pdp-stock__label--out'; label.textContent = 'Produto indisponível'; }
    }
  }

  function updateCTA(variant) {
    var btn = document.getElementById('pdp-btn-add');
    if (!btn) return;

    if (variant.available) {
      btn.disabled        = false;
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('pdp-ctas__main--disabled');
      btn.querySelector('span') && (btn.querySelector('span').textContent = 'Adicionar ao Carrinho');
    } else {
      btn.disabled        = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('pdp-ctas__main--disabled');
      btn.querySelector('span') && (btn.querySelector('span').textContent = 'Produto Indisponível');
    }
  }

  /* ============================================================
     TABS — navegação acessível
     ============================================================ */
  function initTabs() {
    var tabNav    = document.querySelector('.pdp-tabs__nav');
    var tabBtns   = document.querySelectorAll('.pdp-tabs__btn');
    var tabPanels = document.querySelectorAll('.pdp-tabs__panel');

    if (!tabBtns.length) return;

    function activateTab(btn) {
      var targetId = btn.getAttribute('aria-controls');

      tabBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
        b.setAttribute('tabindex', '-1');
      });

      tabPanels.forEach(function (p) {
        p.classList.remove('is-active');
        p.hidden = true;
      });

      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');
      btn.removeAttribute('tabindex');

      var panel = document.getElementById(targetId);
      if (panel) {
        panel.classList.add('is-active');
        panel.hidden = false;
      }
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { activateTab(this); });

      // Suporte a teclado (setas esquerda/direita)
      btn.addEventListener('keydown', function (e) {
        var idx    = Array.from(tabBtns).indexOf(this);
        var newIdx = idx;

        if (e.key === 'ArrowRight') newIdx = (idx + 1) % tabBtns.length;
        if (e.key === 'ArrowLeft')  newIdx = (idx - 1 + tabBtns.length) % tabBtns.length;
        if (e.key === 'Home')       newIdx = 0;
        if (e.key === 'End')        newIdx = tabBtns.length - 1;

        if (newIdx !== idx) {
          e.preventDefault();
          tabBtns[newIdx].focus();
          activateTab(tabBtns[newIdx]);
        }
      });
    });
  }

  /* ============================================================
     HELPERS
     ============================================================ */
  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* Desconto Pix (mesma regra do Liquid: arredonda o desconto ao centavo) */
  function pixCents(cents, pct) {
    return cents - Math.round(cents * pct / 100);
  }

  /* Atualiza o bloco "via Pix" (valor unitario e total da quantidade) */
  function renderPix(qty) {
    var box = document.getElementById('pdp-pix');
    if (!box) return;

    var cents = parseInt(box.dataset.cents, 10) || 0;
    var pct   = parseFloat(box.dataset.pct) || 0;
    if (cents <= 0 || pct <= 0) { box.hidden = true; return; }
    box.hidden = false;

    if (!qty) {
      var qtyInput = document.getElementById('pdp-qty-input');
      qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }

    var valueEl = document.getElementById('pdp-pix-value');
    if (valueEl) valueEl.textContent = formatMoney(pixCents(cents, pct));

    var totalWrap = document.getElementById('pdp-pix-total');
    var totalEl   = document.getElementById('pdp-pix-total-value');
    if (totalWrap && totalEl) {
      totalWrap.hidden = qty < 2;
      totalEl.textContent = formatMoney(pixCents(cents * qty, pct));
    }
  }

  /* ============================================================
     INIT
     ============================================================ */
  function init() {
    initGallery();
    initQtyControl();
    initVariants();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();